/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 1
// module chunks = 0